import { render, staticRenderFns } from "./myCourseAnswer.vue?vue&type=template&id=53062b93&scoped=true&"
import script from "./myCourseAnswer.vue?vue&type=script&lang=js&"
export * from "./myCourseAnswer.vue?vue&type=script&lang=js&"
import style0 from "./myCourseAnswer.vue?vue&type=style&index=0&id=53062b93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53062b93",
  null
  
)

export default component.exports